import { RouteConfig } from 'vue-router';

export const mailTemplateAddRoute: RouteConfig = {
  path: 'add',
  name: 'mailTemplateAdd',
  component: () => import(/* webpackChunkName: "MailTemplateAdd" */ '@/views/mainRoute/mailTemplate/Edit.vue')
};
